import { EntryProps } from "../interface";

export const FilterNoneEntry = (props: EntryProps) => '';
